<template>
<div class="row">
	<div class="col-md-12" style="margin-bottom:10px">
		<button v-if="editar" @click.prevent="$emit('click-editar', item)" class="btn float-right btn-outline-secondary btn-sm">
			<fa-icon style="margin-top: -2px;" icon="pencil-alt"/> Editar
		</button>

		<button v-if="!editar" @click.prevent="$emit('click-editar', item)" class="btn float-right btn-outline-secondary btn-sm">
			<fa-icon style="margin-top: -2px;" icon="search"/> Visualizar
		</button>
	</div>
</div>
</template>

<script>
export default {
	props: ['editar', 'item']
}
</script>



// WEBPACK FOOTER //
// src/views/followair/manutencao/modelo/templates/editar-visualizar.vue